/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon/core/pull-request';
import ObjectBase from '../object-base';
export default function PullRequestObject(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Pull Request' : _ref$label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ObjectBase, {
    label: label,
    size: size,
    testId: testId,
    icon: IconComponent,
    color: "var(--ds-icon-accent-green, #22A06B)"
  });
}